import Platform from '../base';
import unregisteredKeys from './config/keys/unregistered';
import navigationKeys from './config/keys/navigation';
import remoteKeys from './config/keys/remote-keys';
import tizenHelper from './helper';
import { noop } from 'lodash';

class Tizen extends Platform {
  navigationKeys = navigationKeys;
  remoteKeys = remoteKeys;
  deviceInfo = {};

  initialize(opt) {
    super.initialize(opt);

    /* const debugDiv = document.createElement('div');
    debugDiv.id = 'debug';
    debugDiv.setAttribute(
      'style',
      'bottom:0; display: block; position: absolute; z-index: 99999; width: 1280px; min-height: 660px;\n' +
        'background-color: darkblue; padding: 10px 50px; font-size: 32px; color: white; opacity: 0.5; vertical-align: bottom',
    );

    document.body.appendChild(debugDiv);

    console.log = function () {
      var debug = document.getElementById('debug');
      Array.prototype.forEach.call(arguments, function (message) {
        if (typeof message === 'object') message = JSON.stringify(message);
        var newMsg = document.createElement('div');
        newMsg.innerHTML = message;
        debug.appendChild(newMsg);
        debug.scrollTop += 50;
      });
    };*/

    return new Promise((resolve) => {
      this.registerKeys();
      this.setUHDSupport();
      this.setHDRSupport();
      this.deeplink = this.checkDeeplink();
      resolve();
    });
  }
  registerKeys() {
    const tvInputDevice = tizenHelper.getTizenTvInputDevice();

    try {
      unregisteredKeys.forEach((key) => tvInputDevice.registerKey(key));
    } catch (error) {
      console.error('failed to register : ' + error);
    }
  }

  _getDeviceId() {
    return window.webapis.productinfo.getDuid();
  }

  setUHDSupport() {
    try {
      this.deviceInfo.supportsUHD = !!window.webapis.productinfo.isUdPanelSupported();
      if (this.deviceInfo.supportsUHD) {
        this.deviceInfo.supportsUHD8K =
          (window.webapis.productinfo.is8KPanelSupported || noop)() || false;
      }
    } catch (e) {
      this.deviceInfo.supportsUHD = false;
      this.deviceInfo.supportsUHD8K = false;
    }
  }

  setHDRSupport() {
    try {
      this.deviceInfo.supportsHDR = window.webapis.avinfo.isHdrTvSupport();
    } catch (error) {
      this.deviceInfo.supportsHDR = false;
    }
  }

  exit = () => {
    try {
      tizenHelper.getTizenCurrentApp().exit();
    } catch (error) {
      this._notifyError(error, 'Tizen SDK error in the exit');
    }
  };

  supportsUHD() {
    return this.deviceInfo.supportsUHD;
  }

  supportsUHD8K() {
    return this.deviceInfo.supportsUHD8K || false;
  }

  supportsHDR() {
    return this.deviceInfo.supportsHDR;
  }

  getFirmwareVersion() {
    try {
      this.deviceInfo.firmware =
        this.deviceInfo.firmware || window.webapis.productinfo.getFirmware();
      return this.deviceInfo.firmware;
    } catch (e) {
      return Platform.prototype.getFirmwareVersion();
    }
  }

  getModelYear() {
    try {
      this.deviceInfo.year =
        this.deviceInfo.year ||
        parseInt('20' + window.webapis.productinfo.getModelCode().split('_')[0], 10);
      return this.deviceInfo.year;
    } catch (e) {
      return Platform.prototype.getModelYear();
    }
  }

  getModelDiagonal() {
    const tvModel = this.getModelName();
    return parseInt(tvModel.slice(2, 4), 10);
  }

  getModelName() {
    try {
      this.deviceInfo.modelName =
        this.deviceInfo.modelName || window.webapis.productinfo.getRealModel();
      return this.deviceInfo.modelName;
    } catch (e) {
      return Platform.prototype.getModelName();
    }
  }

  getUID() {
    try {
      this.deviceInfo.DUID = this.deviceInfo.DUID || window.webapis.productinfo.getDuid();
      return this.deviceInfo.DUID;
    } catch (e) {
      return Platform.prototype.getUID();
    }
  }

  getDeviceType() {
    return this.getModelYear() < 2017 ? 'OLD_TV' : 'SMART_TV';
  }

  getDeviceRegistrationType() {
    return 'Samsung Tizen';
  }

  getPlatformVersion() {
    try {
      this.deviceInfo.modelCode =
        this.deviceInfo.modelCode || window.webapis.productinfo.getModelCode();
      return this.deviceInfo.modelCode;
    } catch (e) {
      return Platform.prototype.getPlatformVersion();
    }
  }

  getAppVersion() {
    try {
      const marketVersion = tizenHelper.getTizenAppInfo();
      const appVersion = Platform.prototype.getAppVersion();
      return marketVersion ? `${marketVersion} (${appVersion})` : appVersion;
    } catch (e) {
      return Platform.prototype.getAppVersion();
    }
  }

  getConnectionType() {
    try {
      this.deviceInfo.connectionType = 'Unknown';
      const connectionTypeInt = window.webapis.network.getActiveConnectionType();

      switch (connectionTypeInt) {
        case 0:
          this.deviceInfo.connectionType = 'DISCONNECTED';
          break;
        case 1:
          this.deviceInfo.connectionType = 'Wi-Fi';
          break;
        case 2:
          this.deviceInfo.connectionType = 'Cellular';
          break;
        case 3:
          this.deviceInfo.connectionType = 'Ethernet';
          break;
        default:
          this.deviceInfo.connectionType = 'Unknown';
          break;
      }
    } catch (e) {
      return 'Unknown';
    }
  }

  getBrand() {
    return 'Samsung';
  }

  getName() {
    return 'Tizen';
  }

  checkDeeplink() {
    const requestedAppControl = tizenHelper.getTizenRequestedAppControl();
    let appControlData, actionData;

    if (requestedAppControl) {
      appControlData = requestedAppControl.appControl.data;

      for (var i = 0; i < appControlData.length; i++) {
        if (appControlData[i].key === 'PAYLOAD') {
          actionData = JSON.parse(appControlData[i].value[0]).values;
          const parsedActionData = JSON.parse(actionData);

          if (parsedActionData.videoId) {
            return {
              type: 'movie',
              id: parsedActionData.videoId,
            };
          }

          if (parsedActionData.channelId) {
            return {
              type: 'channel',
              id: parsedActionData.channelId,
            };
          }

          if (parsedActionData.seriesId) {
            return {
              type: 'series',
              id: parsedActionData.seriesId,
            };
          }
        }
      }
    } else {
      console.log('no req app control');
    }
  }
}

export default Tizen;
